import { setIsWelcomePage } from '@va/dashboard/actions/ui';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const useIsWelcomePage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setIsWelcomePage(true));
    return () => {
      dispatch(setIsWelcomePage(false));
    };
  }, [dispatch]);
};
